angular.module('MyHippoProducer.Services').factory('Auth0Service', function (angularAuth0, $cookies, $rootScope, $http, $stateParams) {
    const MINUTE_IN_MS = 60000;

    /** How long before POD Token expiry we should request a new one. */
    const POD_TOKEN_EXPIRATION_LEEWAY_IN_MS = 20 * MINUTE_IN_MS;

    /** How often should we refresh Auth0 Session and check if we should request a new POD Token. */
    const POD_TOKEN_REFRESH_INTERVAL_IN_MS = 15 * MINUTE_IN_MS;

    const {API_HOST: apiHost} = window.appConfig;

    const isPodTokenExpiringIn = (podToken, expiringInMs) => {
        const { exp: expirationUnixTimeInSeconds } = JSON.parse(atob(podToken.split('.')[1]));
        const expirationUnixTimeInMs = expirationUnixTimeInSeconds * 1000;

        const now = Date.now();

        return now >= expirationUnixTimeInMs - expiringInMs;
    };

    const getAuthTokenFromAuthResult = (authResult) => {
        if (!authResult) {
            return undefined;
        }

        if (typeof authResult !== 'object') {
            return undefined;
        }

        if (!('accessToken' in authResult)) {
            return undefined;
        }

        return authResult.accessToken;
    };

    const getLocationHostName = () => window.location.hostname;
    const getDomainName = () => getLocationHostName().split('.').slice(-2).join('.');
    const getCookieOptions = () => ({domain: '.' + getDomainName(),});

    const refreshPodToken = () => new Promise((resolve, reject) => {
        const podToken = $cookies.get('pod_token', getCookieOptions());

        if (!podToken) {
            $rootScope.$broadcast('user.logout');
            return reject(new Error('missing existing POD token cookie'));
        }

        angularAuth0.checkSession({}, (error, authResult) => {
            try {
                if (error) {
                    throw new Error(error.error);
                }

                const accessToken = getAuthTokenFromAuthResult(authResult);

                if (!accessToken) {
                    throw new Error('authResult is missing accessToken');
                }

                if (!isPodTokenExpiringIn(podToken, POD_TOKEN_EXPIRATION_LEEWAY_IN_MS)) {
                    resolve();
                    return;
                }

                $http({
                    url: `${apiHost}/v1/producer/user/refreshPodToken`,
                    method: 'POST',
                    data: { accessToken },
                    headers: { Authorization: `Bearer ${podToken}` }
                }).then((response) => {
                    $cookies.put('pod_token', response.data.token, getCookieOptions());
                    resolve();
                }).catch(error => {
                    console.log(error);
                    reject(error);
                });
            } catch (error) {
                console.log('Cannot authenticate an user', { error });

                if (error.message === 'login_required') {
                    $rootScope.$broadcast('user.logout');
                }

                reject(error);
            }
        });
    });

    const startRefreshingPodToken = () => {
        void refreshPodToken();

        setInterval(() => {
            void refreshPodToken();
        }, POD_TOKEN_REFRESH_INTERVAL_IN_MS);
    };

    const getPodToken = () => {
        const podToken = $cookies.get('pod_token', getCookieOptions());

        if (podToken && !isPodTokenExpiringIn(podToken, 0)) {
            return Promise.resolve(podToken);
        }

        console.log('refreshing POD token first');

        return refreshPodToken().then(() => {
            const freshPodToken = $cookies.get('pod_token', getCookieOptions());
            return freshPodToken;
        });
    };

    return { startRefreshingPodToken, getPodToken };
});
